import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type PurchaseNotification = {
  id: number;
  name: string;
  location: string;
  timeAgo: string;
};
const FAKE_PURCHASES: Omit<PurchaseNotification, 'id'>[] = [{
  name: 'Martín L.',
  location: 'Buenos Aires',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'Florencia S.',
  location: 'Córdoba',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Nicolás P.',
  location: 'Rosario',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Valentina R.',
  location: 'Mendoza',
  timeAgo: 'hace 12 minutos'
}, {
  name: 'Tomás G.',
  location: 'Tucumán',
  timeAgo: 'hace 15 minutos'
}, {
  name: 'Agustina M.',
  location: 'La Plata',
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Santiago D.',
  location: 'Mar del Plata',
  timeAgo: 'hace 22 minutos'
}, {
  name: 'Julieta K.',
  location: 'Salta',
  timeAgo: 'hace 25 minutos'
}, {
  name: 'Federico B.',
  location: 'Santa Fe',
  timeAgo: 'hace 30 minutos'
}, {
  name: 'Carolina H.',
  location: 'Neuquén',
  timeAgo: 'hace 35 minutos'
}, {
  name: 'Ramiro V.',
  location: 'Bahía Blanca',
  timeAgo: 'hace 40 minutos'
}, {
  name: 'Milagros T.',
  location: 'San Juan',
  timeAgo: 'hace 45 minutos'
}];
export function PurchaseNotifications() {
  const [currentNotification, setCurrentNotification] = useState<PurchaseNotification | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const showNotification = useCallback(() => {
    const randomPurchase = FAKE_PURCHASES[Math.floor(Math.random() * FAKE_PURCHASES.length)];
    setCurrentNotification({
      ...randomPurchase,
      id: Date.now()
    });
    setIsVisible(true);
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    // Then show every 30-60 seconds randomly
    const interval = setInterval(() => {
      const randomDelay = Math.random() * 30000 + 30000; // 30-60s
      setTimeout(showNotification, randomDelay % 30000);
    }, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <div className="fixed bottom-6 left-6 z-[90] max-w-xs" data-id="element-268">
      <AnimatePresence data-id="element-269">
        {isVisible && currentNotification && <motion.div key={currentNotification.id} initial={{
        opacity: 0,
        y: 40,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        x: -20
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="bg-gray-900/95 backdrop-blur-md border border-[#00f0ff]/30 rounded-xl p-4 shadow-[0_0_20px_rgba(0,240,255,0.15)] flex items-start gap-3" data-id="element-270">
            <div className="bg-[#f5c518]/20 p-2 rounded-lg shrink-0" data-id="element-271">
              <ShoppingBagIcon className="w-5 h-5 text-[#f5c518]" data-id="element-272" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-273">
              <p className="text-white text-sm font-medium leading-tight" data-id="element-274">
                {currentNotification.name}
              </p>
              <p className="text-gray-400 text-xs mt-0.5" data-id="element-275">
                compró el Ebook desde {currentNotification.location}
              </p>
              <p className="text-gray-500 text-[11px] mt-1" data-id="element-276">
                {currentNotification.timeAgo}
              </p>
            </div>

            <button onClick={() => setIsVisible(false)} className="text-gray-500 hover:text-gray-300 transition-colors shrink-0 mt-0.5" aria-label="Cerrar notificación" data-id="element-277">
              <XIcon className="w-4 h-4" data-id="element-278" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}